// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Home page ───────────────────────────────────────────────────────────── */

/* Welcome banner */
.ecr-home-banner {
  background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);
  border: 1px solid #e5e7eb;
  border-left: 4px solid #86BC25;
  border-radius: 12px;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s;
}

.ecr-home-banner:hover {
  box-shadow: 0 4px 12px rgba(134, 188, 37, 0.08);
}

.ecr-home-banner__content {
  padding: 28px 32px;
}

.ecr-home-banner__title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px 0;
  letter-spacing: -0.01em;
}

.ecr-home-banner__body {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
}

/* System status bar */
.ecr-home-status-bar {
  display: flex;
  align-items: center;
  gap: 24px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 18px 24px;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s;
}

.ecr-home-status-bar:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.ecr-home-status-bar__header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  padding-right: 24px;
  border-right: 2px solid #e5e7eb;
  flex-shrink: 0;
}

.ecr-home-status-bar__header svg {
  font-size: 22px;
  color: #86BC25;
}

.ecr-home-status-bar__services {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
  flex-wrap: wrap;
}

.ecr-home-status-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ecr-home-status-item__label {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
}

.ecr-home-status-item__badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid;
  transition: transform 0.15s;
}

.ecr-home-status-item__badge:hover {
  transform: scale(1.05);
}

.ecr-home-status-item__badge--healthy {
  background: #e6f9f1;
  color: #86BC25;
  border-color: #86BC25;
}

.ecr-home-status-item__badge--error {
  background: #fee;
  color: #dc2626;
  border-color: #dc2626;
}

.ecr-home-status-item__badge--loading {
  background: #f3f4f6;
  color: #6b7280;
  border-color: #d1d5db;
}

.ecr-home-status-item__badge svg {
  font-size: inherit;
}

.ecr-home-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
}

.ecr-home-status-dot--loading {
  animation: ecr-home-status-pulse 1.5s ease-in-out infinite;
}

.ecr-home-status-bar__details-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: #86BC25;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;
  flex-shrink: 0;
}

.ecr-home-status-bar__details-btn:hover {
  background: #6fa019;
  transform: translateY(-1px);
}

.ecr-home-status-bar__details-btn:active {
  transform: translateY(0);
}

.ecr-home-status-bar__details-btn svg {
  font-size: 18px;
  transition: transform 0.2s;
}

.ecr-home-status-bar__details-btn:hover svg {
  transform: translateX(3px);
}

@keyframes ecr-home-status-pulse {
  0%, 100% {
    opacity: 0.4;
    transform: scale(0.9);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

/* Responsive status bar */
@media (max-width: 1024px) {
  .ecr-home-status-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .ecr-home-status-bar__header {
    padding-right: 0;
    border-right: none;
    padding-bottom: 12px;
    border-bottom: 2px solid #e5e7eb;
    width: 100%;
  }

  .ecr-home-status-bar__services {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
  }

  .ecr-home-status-bar__details-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Tool grid */
.ecr-home-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 18px;
}

/* Tool card */
.ecr-home-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-left: 4px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px 18px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: border-left-color 0.18s, box-shadow 0.18s, background 0.18s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.ecr-home-card:hover {
  border-left-color: #86BC25;
  box-shadow: 0 6px 20px rgba(0, 166, 81, 0.1);
  background: #f0faf5;
}

.ecr-home-card__icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: #e6f6ee;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #86BC25;
}

.ecr-home-card__icon-wrap svg {
  font-size: 24px;
}

.ecr-home-card__body {
  flex: 1 1;
  min-width: 0;
}

.ecr-home-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
}

.ecr-home-card__label {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.ecr-home-card__tag {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #005c2f;
  background: #e6f6ee;
  border: 1px solid #b2e8cc;
  padding: 2px 7px;
  border-radius: 20px;
}

.ecr-home-card__desc {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  line-height: 1.55;
}

.ecr-home-card__arrow {
  font-size: 22px;
  color: #d1d5db;
  flex-shrink: 0;
  transition: color 0.15s, transform 0.15s;
}

.ecr-home-card:hover .ecr-home-card__arrow {
  color: #86BC25;
  transform: translateX(3px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/EcrOpsHome.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uEAAuE;EACvE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":["/* ── Home page ───────────────────────────────────────────────────────────── */\n\n/* Welcome banner */\n.ecr-home-banner {\n  background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);\n  border: 1px solid #e5e7eb;\n  border-left: 4px solid #86BC25;\n  border-radius: 12px;\n  margin-bottom: 32px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s;\n}\n\n.ecr-home-banner:hover {\n  box-shadow: 0 4px 12px rgba(134, 188, 37, 0.08);\n}\n\n.ecr-home-banner__content {\n  padding: 28px 32px;\n}\n\n.ecr-home-banner__title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 8px 0;\n  letter-spacing: -0.01em;\n}\n\n.ecr-home-banner__body {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* System status bar */\n.ecr-home-status-bar {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 18px 24px;\n  margin-bottom: 32px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s;\n}\n\n.ecr-home-status-bar:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n}\n\n.ecr-home-status-bar__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  padding-right: 24px;\n  border-right: 2px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.ecr-home-status-bar__header svg {\n  font-size: 22px;\n  color: #86BC25;\n}\n\n.ecr-home-status-bar__services {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex: 1;\n  flex-wrap: wrap;\n}\n\n.ecr-home-status-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ecr-home-status-item__label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.ecr-home-status-item__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid;\n  transition: transform 0.15s;\n}\n\n.ecr-home-status-item__badge:hover {\n  transform: scale(1.05);\n}\n\n.ecr-home-status-item__badge--healthy {\n  background: #e6f9f1;\n  color: #86BC25;\n  border-color: #86BC25;\n}\n\n.ecr-home-status-item__badge--error {\n  background: #fee;\n  color: #dc2626;\n  border-color: #dc2626;\n}\n\n.ecr-home-status-item__badge--loading {\n  background: #f3f4f6;\n  color: #6b7280;\n  border-color: #d1d5db;\n}\n\n.ecr-home-status-item__badge svg {\n  font-size: inherit;\n}\n\n.ecr-home-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.ecr-home-status-dot--loading {\n  animation: ecr-home-status-pulse 1.5s ease-in-out infinite;\n}\n\n.ecr-home-status-bar__details-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  background: #86BC25;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s, transform 0.15s;\n  flex-shrink: 0;\n}\n\n.ecr-home-status-bar__details-btn:hover {\n  background: #6fa019;\n  transform: translateY(-1px);\n}\n\n.ecr-home-status-bar__details-btn:active {\n  transform: translateY(0);\n}\n\n.ecr-home-status-bar__details-btn svg {\n  font-size: 18px;\n  transition: transform 0.2s;\n}\n\n.ecr-home-status-bar__details-btn:hover svg {\n  transform: translateX(3px);\n}\n\n@keyframes ecr-home-status-pulse {\n  0%, 100% {\n    opacity: 0.4;\n    transform: scale(0.9);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n}\n\n/* Responsive status bar */\n@media (max-width: 1024px) {\n  .ecr-home-status-bar {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .ecr-home-status-bar__header {\n    padding-right: 0;\n    border-right: none;\n    padding-bottom: 12px;\n    border-bottom: 2px solid #e5e7eb;\n    width: 100%;\n  }\n\n  .ecr-home-status-bar__services {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .ecr-home-status-bar__details-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Tool grid */\n.ecr-home-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 18px;\n}\n\n/* Tool card */\n.ecr-home-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-left: 4px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 20px 18px;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: border-left-color 0.18s, box-shadow 0.18s, background 0.18s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.ecr-home-card:hover {\n  border-left-color: #86BC25;\n  box-shadow: 0 6px 20px rgba(0, 166, 81, 0.1);\n  background: #f0faf5;\n}\n\n.ecr-home-card__icon-wrap {\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  background: #e6f6ee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #86BC25;\n}\n\n.ecr-home-card__icon-wrap svg {\n  font-size: 24px;\n}\n\n.ecr-home-card__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.ecr-home-card__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 5px;\n}\n\n.ecr-home-card__label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.ecr-home-card__tag {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #005c2f;\n  background: #e6f6ee;\n  border: 1px solid #b2e8cc;\n  padding: 2px 7px;\n  border-radius: 20px;\n}\n\n.ecr-home-card__desc {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.55;\n}\n\n.ecr-home-card__arrow {\n  font-size: 22px;\n  color: #d1d5db;\n  flex-shrink: 0;\n  transition: color 0.15s, transform 0.15s;\n}\n\n.ecr-home-card:hover .ecr-home-card__arrow {\n  color: #86BC25;\n  transform: translateX(3px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
